module.exports = __webpack_public_path__ + "public/files/img/wp-type-2.dff3b956.png";